export const isLoading = (state) => state.loading

export const getSchema = (state) => state.schema

export const getViewEntityType = (state) => state.viewEntityType

export const getData = (state) => state.data

export const getId = (state) => state.id



// WEBPACK FOOTER //
// ./src/store/modules/resource/getters.js